import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const toastRecipeDefaultVariants = {
  "status": "info",
  "size": "md",
  "state": "collapsed"
}
const toastRecipeCompoundVariants = []

const toastRecipeSlotNames = [
  [
    "root",
    "toast__root"
  ],
  [
    "viewport",
    "toast__viewport"
  ],
  [
    "list",
    "toast__list"
  ],
  [
    "header",
    "toast__header"
  ]
]
const toastRecipeSlotFns = /* @__PURE__ */ toastRecipeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, toastRecipeDefaultVariants, getSlotCompoundVariant(toastRecipeCompoundVariants, slotName))])

const toastRecipeFn = memo((props = {}) => {
  return Object.fromEntries(toastRecipeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const toastRecipeVariantKeys = [
  "status",
  "size",
  "state"
]
const getVariantProps = (variants) => ({ ...toastRecipeDefaultVariants, ...compact(variants) })

export const toastRecipe = /* @__PURE__ */ Object.assign(toastRecipeFn, {
  __recipe__: false,
  __name__: 'toastRecipe',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: toastRecipeVariantKeys,
  variantMap: {
  "status": [
    "info",
    "success",
    "warning",
    "fatal",
    "error"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "state": [
    "collapsed",
    "expanded"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, toastRecipeVariantKeys)
  },
  getVariantProps
})